<template>
  <app-slide>
    <article class="layout" id="start">
        <div class="container">
          <div class="row">
              <div class="col-xs-12 text-content">
                  <h2 class="margin-bottom-2">{{getTranslation('artists')}}</h2>
                  <div class="block-style margin-bottom-2">
                    <p>{{getTranslation('sort-by')}}:</p>
                    <p :class="{'active': isOrder('code')}" @click="orderCode">{{getTranslation('code')}}</p>
                    <p :class="{'active': isOrder('firstName')}" @click="orderFirstName">{{getTranslation('first-name')}}</p>
                    <p :class="{'active': isOrder('lastName')}" @click="orderLastName">{{getTranslation('last-name')}}</p>
                  </div>
                  {{statusText}}
                  <ul class="list-style">
                    <router-link tag="li" :to="getUrl(item.code)" v-for="item in orderBy(items, order)" :key="item.id">{{item.title}}<span class="code">{{item.code}}.00</span></router-link>
                  </ul>
              </div>
          </div>
          </div>
    </article>
    </app-slide>
</template>


<script>
  import {store} from '../store/store'
  import appSlide from '../transitions/AppSlide'
  import mixinLanguages from '../mixins/Language'
  // import HomeRiboca from '../components/HomeRiboca'
  // import slide from '../mixins/PageSlide'
  export default {
    name: 'artistIndex',
    components: {
      appSlide
    },
    mixins: [mixinLanguages],
    data() {
      return {
        items:[],
        order: 'code',
        statusText:'Loading artists...',
      }
    },
    mounted () {
      this.getArtists();
      let thisUrl = '00/00';
      store.dispatch('setDestUrl', thisUrl);
      store.dispatch('setDestChange', false);
    },
    computed:{
      lang() { 
        return this.$store.state.langUrl;
      },
    },
    watch: {
      // use the watch to react on the value change.
      lang(newValue) {
        this.getArtists();
      },
    },
    methods: {
      isOrder(inputVal) {
        return inputVal == this.order;
      },
      getUrl(code) {
        return String('/' + code + '/00');
      },
      getArtists () {
        let baseUrl = this.$store.getters.getBaseUrl;
        let lang = this.$store.getters.getLangState;
        let url = baseUrl + lang + '/api/mobile/v1/artists.json';
        this.$http.get(url).then((response) => {
          this.items = response.data.data;
          this.statusText = "";
        });
      },
      orderFirstName(event) {
        this.order="firstName";
      },
      orderCode(event) {
        this.order="code";
      },
      orderLastName(event) {
        this.order="lastName";
      }
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/ArtistIndex.vue